/* eslint-disable no-console */

import Vue from 'vue'
import VueRouter from 'vue-router'
// layouts
import DefaultLayout from '@/layouts/Default.vue'
import NoNav from '@/layouts/NoNav.vue'

Vue.use(VueRouter)
const routes = [
  /* Login, default path both go to login   */
  {
    path: '/',
    component: NoNav,
    children: [
      {
        path: '/',
        name: 'default',
        component: () => import('@/views/Login.vue'),
        meta: {
          title: 'Login'
        }
      },
      /* Logoff */
      {
        path: '/logoff',
        name: 'logoff',
        component: () => import('@/views/Logoff.vue'),
        meta: {
          title: 'Logoff',
          breadcrumbs: []
        }
      },
      /* bad request */
      {
        path: '/400',
        name: 400,
        component: () => import('@/views/errors/400.vue'),
        meta: {
          title: 'Error!'
        }
      },
      /* auth */
      {
        path: '/401',
        name: 401,
        component: () => import('@/views/errors/401.vue'),
        meta: {
          title: 'Error!'
        }
      },
      /* forebidden */
      {
        path: '/403',
        name: 403,
        component: () => import('@/views/errors/403.vue'),
        meta: {
          title: 'Error!'
        }
      },
      /* not found */
      {
        path: '/404',
        name: 404,
        component: () => import('@/views/errors/404.vue'),
        meta: {
          title: 'Error!'
        }
      },
      /* internal */
      {
        path: '/500',
        name: 500,
        component: () => import('@/views/errors/500.vue'),
        meta: {
          title: 'Error!'
        }
      },
      /* disabled account */
      {
        path: '/disabled',
        name: 'disabled',
        component: () => import('@/views/errors/DisabledAccount.vue'),
        meta: {
          title: 'Account Disabled'
        }
      }
    ]
  },
  /* Post login dashboard */
  /* Auth requirement in meta data */
  {
    path: '/*',
    component: DefaultLayout,
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: {
          requiresAuth: true,
          title: 'Your Dashboard',
          icon: 'home',
          breadcrumbs: []
        }
      },
      /* Operate */
      {
        path: '/operate/guidance',
        name: 'operate.guidance',
        component: () => import('@/views/operate/Guidance.vue'),
        meta: {
          requiresAuth: true,
          title: 'Guidance',
          icon: 'mdi-state-machine',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Operate' },
            { name: 'Guidance' }
          ]
        }
      },
      {
        path: '/operate/generator',
        name: 'operate.generator',
        component: () => import('@/views/operate/Generator.vue'),
        meta: {
          requiresAuth: true,
          title: 'Generator Run Times',
          icon: 'mdi-state-machine',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Operate' },
            { name: 'Generator Run Times' }
          ]
        }
      },
      {
        path: '/demo/guidance/:exId',
        name: 'demo.guidance',
        component: () => import('@/views/demo/Guidance.vue'),
        meta: {
          requiresAuth: true,
          title: 'Guidance',
          icon: 'mdi-state-machine',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Operate' },
            { name: 'Guidance' }
          ]
        }
      },
      /* Plan */
      {
        path: '/demo/engine',
        name: 'demo.engine',
        component: () => import('@/views/demo/SimulateEngine.vue'),
        meta: {
          requiresAuth: true,
          title: 'Simulation Engine',
          icon: 'mdi-strategy',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Plan' },
            { name: 'Simulation' },
            { name: 'Engine' }
          ]
        }
      },
      {
        path: '/demo/engine/resi',
        name: 'demo.engine.resi',
        component: () => import('@/views/demo/SimulateEngineResi.vue'),
        meta: {
          requiresAuth: true,
          title: 'Simulation Engine Residential',
          icon: 'mdi-strategy',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Plan' },
            { name: 'Simulation' },
            { name: 'Residential' }
          ]
        }
      },
      {
        path: '/demo/solar',
        name: 'demo.solar',
        component: () => import('@/views/demo/SimulateSolar.vue'),
        meta: {
          requiresAuth: true,
          title: 'Simulation: Solar',
          icon: 'mdi-strategy',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Plan' },
            { name: 'Simulation' },
            { name: 'Solar' }
          ]
        }
      },
      {
        path: '/demo/health',
        name: 'demo.health',
        component: () => import('@/views/demo/SimulateHealth.vue'),
        meta: {
          requiresAuth: true,
          title: 'Simulation: Healthcare',
          icon: 'mdi-strategy',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Plan' },
            { name: 'Simulation' },
            { name: 'Healthcare' }
          ]
        }
      },
      /* Report */
      {
        path: '/report/performance/summary',
        name: 'report.performance.summary',
        component: () => import('@/views/report/PerformanceSummary.vue'),
        meta: {
          requiresAuth: true,
          title: 'Performance Summary',
          icon: 'mdi-file-chart',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Report' },
            { name: 'Performance Summary' }
          ]
        }
      },
      {
        path: '/report/performance/:x?',
        name: 'report.performance',
        component: () => import('@/views/report/Performance.vue'),
        meta: {
          requiresAuth: true,
          title: 'Performance',
          icon: 'mdi-file-chart',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Report' },
            { name: 'Performance' }
          ]
        }
      },
      {
        path: '/demo/performance/:x?',
        name: 'demo.performance',
        component: () => import('@/views/demo/Performance.vue'),
        meta: {
          requiresAuth: true,
          title: 'Performance',
          icon: 'mdi-file-chart',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Report' },
            { name: 'Performance' }
          ]
        }
      },
      {
        path: '/demo/report/sustain',
        name: 'demo.report.sustain',
        component: () => import('@/views/demo/Sustainability.vue'),
        meta: {
          requiresAuth: true,
          title: 'Sustainability',
          icon: 'mdi-file-chart',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Report' },
            { name: 'Sustainability' }
          ]
        }
      },
      {
        path: '/demo/report/spend/',
        name: 'demo.report.spend',
        component: () => import('@/views/demo/Spend.vue'),
        meta: {
          requiresAuth: true,
          title: 'Daily Spend #1',
          icon: 'mdi-file-chart',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Report' },
            { name: 'Daily Spend #1' }
          ]
        }
      },
      {
        path: '/demo/report/spend2/',
        name: 'demo.report.spend2',
        component: () => import('@/views/demo/Spend2.vue'),
        meta: {
          requiresAuth: true,
          title: 'Daily Spend #2',
          icon: 'mdi-file-chart',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Report' },
            { name: 'Daily Spend #2' }
          ]
        }
      },
      /* Configure */
      {
        path: '/config/assets',
        name: 'config.assets',
        component: () => import('@/views/configure/Assets.vue'),
        meta: {
          requiresAuth: true,
          title: 'Assets Configuration',
          icon: 'settings',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Configure' },
            { name: 'Assets' }
          ]
        }
      },
      {
        path: '/config/facility',
        name: 'config.facility',
        component: () => import('@/views/configure/Facility.vue'),
        meta: {
          requiresAuth: true,
          title: 'Facility Configuration',
          icon: 'settings',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Configure' },
            { name: 'Facility' }
          ]
        }
      },
      /* Admin */
      {
        path: '/admin/peak',
        name: 'admin.peak',
        component: () => import('@/views/admin/CoincidentPeak.vue'),
        meta: {
          requiresAuth: true,
          title: 'Coincident Peak Configuration',
          icon: 'vpn_key',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Admin' },
            { name: 'Coincident Peak Config' }
          ]
        }
      },
      {
        path: '/admin/accounts',
        name: 'admin.accounts',
        component: () => import('@/views/admin/account/ListAccounts.vue'),
        meta: {
          requiresAuth: true,
          title: 'Accounts',
          icon: 'vpn_key',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Admin' },
            { name: 'Accounts' }
          ]
        }
      },
      {
        path: '/admin/facilities',
        name: 'admin.facilities',
        component: () => import('@/views/admin/facility/ListFacilities.vue'),
        meta: {
          requiresAuth: true,
          title: 'Facilities',
          icon: 'vpn_key',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Admin' },
            { name: 'Facilities' }
          ]
        }
      },
      {
        path: '/admin/facility/edit',
        name: 'admin.facility.edit',
        component: () => import('@/views/admin/facility/EditFacility.vue'),
        meta: {
          requiresAuth: true,
          title: 'Edit Facility',
          icon: 'vpn_key',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Admin' },
            { name: 'Edit Facility' }
          ]
        }
      },
      {
        path: '/admin/constraints/master',
        name: 'admin.constraints.master',
        component: () => import('@/views/admin/constraints/Master.vue'),
        meta: {
          requiresAuth: true,
          title: 'Master Constraints',
          icon: 'vpn_key',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Admin' },
            { name: 'Master' }
          ]
        }
      },
      /* User */
      {
        path: '/contact',
        name: 'user.contact',
        component: () => import('@/views/Contact.vue'),
        meta: {
          title: 'Contact Us',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Contact' }
          ]
        }
      },
      /* Help */
      {
        path: '/help/guidance',
        name: 'help.guidance',
        component: () => import('@/views/help/Guidance.vue'),
        meta: {
          requiresAuth: true,
          title: 'Help-Guidance',
          breadcrumbs: [
            { name: 'Home', to: { name: 'home' } },
            { name: 'Operate' },
            { name: 'Guidance', to: { name: 'guidance' } },
            { name: 'Help' }
          ]
        }
      }
    ]
  },
  /* no layout */
  /* CATCH ALL */
  /* Tried typing in any path, just displays blank screen - FIXME **/
  { path: '*', redirect: '/404' },
  { path: '/*', redirect: '/404' }
]

export default new VueRouter({ mode: 'hash', routes })
